import { render, staticRenderFns } from "./nut-reward.vue?vue&type=template&id=a1a20e82&scoped=true&"
import script from "./nut-reward.vue?vue&type=script&lang=js&"
export * from "./nut-reward.vue?vue&type=script&lang=js&"
import style0 from "./nut-reward.vue?vue&type=style&index=0&id=a1a20e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a20e82",
  null
  
)

export default component.exports